import React from 'react'
import { Box } from '@mui/material'
import type { CrosswalkMappingSetType } from 'domains/scope-and-sequence/types'
import { ValidPercentage } from 'domains/scope-and-sequence/components'

export function CrosswalkAlignmentDisplay<T extends { id: number }>({
  item,
}: {
  item: T
  columnData: { key: string }
}) {
  const alignments = (item as unknown as CrosswalkMappingSetType).alignments
  if (!alignments || !alignments.length) {
    return <Box>No Standard Alignments</Box>
  }

  return (
    <Box>
      <p>
        {'Target: '}
        <ValidPercentage alignments={alignments} param={'target_valid'} />
      </p>
      <p>
        {'Source: '}
        <ValidPercentage alignments={alignments} param={'source_valid'} />
      </p>
    </Box>
  )
}
